const useIsFirstElement = (props) => {
  const { editor, element } = props
  const is = element === editor.children[0]
  return is
}

export { useIsFirstElement }
export default useIsFirstElement
